/**
 * Environment helpers.
 *
 * Sentry: always on for production + preview (configured in sentry.*.config.ts).
 * Analytics (PostHog, GTM): gated behind ANALYTICS_ENABLED kill switch.
 */

export const IS_PRODUCTION = process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
export const IS_PREVIEW = process.env.NEXT_PUBLIC_VERCEL_ENV === "preview"
export const IS_DEV = process.env.NODE_ENV === "development"

export const ANALYTICS_ENABLED =
  IS_PRODUCTION && process.env.NEXT_PUBLIC_ANALYTICS_ENABLED === "true"
